import React, { useCallback } from 'react';
import { useSnackbar } from 'notistack';
import { Button } from '@material-ui/core';

function formatErrorToString(error) {
    let stringMessage = 'An unexpected error occurred';
    try {
        if (error.response?.data) {
            let data = error.response.data;

            if (typeof data === 'string') {
                data = JSON.parse(data);
            }
            stringMessage = data?.message;
        } else if (typeof error === 'object' && error?.response?.body?.message) {
            stringMessage = error?.response?.body?.message;
        } else if (typeof error === 'object' && error?.message) {
            stringMessage = error?.message;
        } else if (typeof error === 'string') {
            stringMessage = error;
        } else {
            stringMessage = error.toString();
        }
    } catch (err) {
        console.log(error, err);
    }
    return stringMessage;
}

export function useNotify() {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const notifySuccess = useCallback(
        (message, persist = false) => {
            enqueueSnackbar(message, {
                variant: 'success',
                persist,
                action: persist
                    ? key => {
                          return (
                              <>
                                  <Button onClick={() => closeSnackbar(key)}>Close</Button>
                              </>
                          );
                      }
                    : undefined
            });
        },
        [enqueueSnackbar, closeSnackbar]
    );
    const notifyInfo = useCallback(
        (message, persist = false) => {
            enqueueSnackbar(message, {
                variant: 'info',
                persist,
                action: persist
                    ? key => {
                          return (
                              <>
                                  <Button onClick={() => closeSnackbar(key)}>Close</Button>
                              </>
                          );
                      }
                    : undefined
            });
        },
        [enqueueSnackbar, closeSnackbar]
    );
    const notifyError = useCallback(
        message => {
            enqueueSnackbar(formatErrorToString(message), {
                variant: 'error',
                persist: true,
                action: key => {
                    return (
                        <>
                            <Button onClick={() => closeSnackbar(key)}>Close</Button>
                        </>
                    );
                }
            });
        },
        [enqueueSnackbar, closeSnackbar]
    );

    return {
        notifySuccess,
        notifyError,
        notifyInfo
    };
}
